
import { Api, LocalDictionaryFactory } from  './../../api/api.module'

import { IUserSession } from '../../../helpers/user-session'
import { SimcardsCreateEditController } from './simcards-create-edit.directive.controller'

import './simcards-create-edit.scss'
import * as TEMPLATE from './simcards-create-edit.tpl.html'

export class SimcardCreateEditDirective implements ng.IDirective {
    restrict = 'E'//only matches element name, odniesienie do layout.tpl.html simcards-create-edit

    controller = ['$scope', '$q', '$timeout', 'api', 'localDictionary', 'userSession',
        ($scope: any, $q: ng.IQService, $timeout: ng.ITimeoutService, api: Api, localDictionary: LocalDictionaryFactory, userSession: IUserSession) =>
            new SimcardsCreateEditController($scope, $q, $timeout, api, localDictionary, userSession)]
    template = TEMPLATE
}